import React from "react";
import style from "./index.module.scss";
import Status from "./components/Status";
import { Tooltip } from "antd";
import { VoteItem, VoteState, VoteType } from "service/vote";
import classNames from "classnames";
import DropDown from "./components/DropDown";
import Links from "./components/Links";
import Statics from "./components/Statics";
import moment from "moment";
import { renderValidityTime } from "utils/common";

interface ListItemProps {
    weekTimeId: number;
    data: VoteItem;
    onClick: (params?: any) => void;
    onChange: () => void;
    onEnd?: () => void;
}

export default function ListItem({
    weekTimeId,
    data,
    onClick,
    onChange,
    onEnd
}: ListItemProps) {
    return (
        <div className={classNames(style.root, style[`type${data.type}`])}>
            <h1 className={style.title}>
                <Tooltip title={data.title}>{data.title}</Tooltip>

                <Status status={data.status} />
            </h1>

            <div className={style.info}>
                {data.type !== VoteType.Judge && (
                    <span>选项设置 {data.answersNumber} ｜</span>
                )}
                活动时长 {renderValidityTime(data.validityTime)}
                {data.startTime && (
                    <span>
                        ｜ 开始时间{" "}
                        {moment(data.startTime).format("MM-DD HH:mm")}
                    </span>
                )}
                {data.endTime && (
                    <span>
                        ｜ 结束时间 {moment(data.endTime).format("MM-DD HH:mm")}
                    </span>
                )}
            </div>

            <div className={style.tools}>
                {data.status !== VoteState.Done && (
                    <Links
                        voteId={data.id}
                        onShowVote={onClick}
                        onEnd={onEnd}
                        isStart={data.status === VoteState.InProgress}
                    />
                )}
                {data.status === VoteState.Done && (
                    <Statics
                        onClick={onClick}
                        courseStuCount={data.courseStuCount}
                        voteStuCount={data.voteStuCount}
                        notVoteStuCount={data.notVoteStuCount}
                    />
                )}
                <DropDown
                    weekTimeId={weekTimeId}
                    voteId={data.id}
                    data={data}
                    onShowVote={onClick}
                    onChange={onChange}
                />
            </div>
        </div>
    );
}
